import * as types from './types';
import { createRoutine } from 'redux-saga-routines';

export const fetchInvoices = createRoutine(types.FETCH_INVOICES);
export const fetchInvoice = createRoutine(types.FETCH_INVOICE);
export const fetchInvoicePdf = createRoutine(types.FETCH_INVOICE_PDF);
